import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import BookingModal from './components/BookingModal';
import ScrollToTop from './components/ScrollToTop';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ServiceDetailPage from './pages/ServiceDetailPage';
import ContactPage from './pages/ContactPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsConditionsPage from './pages/TermsConditionsPage';
import BlogListingPage from './pages/BlogListingPage';
import BlogDetailPage from './pages/BlogDetailPage';
import ThankYouPage from './pages/ThankYouPage';
import ThankYouDemoPage from './pages/ThankYouDemoPage';
import { Toaster } from './components/ui/toaster';
import './App.css';

function App() {
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);

  const handleBookingClick = () => {
    setIsBookingModalOpen(true);
  };

  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar onBookingClick={handleBookingClick} />
        
        <main>
          <Routes>
            <Route path="/" element={<HomePage onBookingClick={handleBookingClick} />} />
            <Route path="/about" element={<div className="pt-20"><AboutPage onBookingClick={handleBookingClick} /></div>} />
            <Route path="/services" element={<div className="pt-20"><ServicesPage onBookingClick={handleBookingClick} /></div>} />
            <Route path="/services/:serviceId" element={<div className="pt-20"><ServiceDetailPage onBookingClick={handleBookingClick} /></div>} />
            <Route path="/contact" element={<div className="pt-20"><ContactPage /></div>} />
            <Route path="/privacy-policy" element={<div className="pt-20"><PrivacyPolicyPage /></div>} />
            <Route path="/terms-conditions" element={<div className="pt-20"><TermsConditionsPage /></div>} />
            <Route path="/blog" element={<div className="pt-20"><BlogListingPage /></div>} />
            <Route path="/blog/:slug" element={<BlogDetailPage onBookingClick={handleBookingClick} />} />
            <Route path="/thank-you" element={<ThankYouPage />} />
            <Route path="/thank-you-demo" element={<ThankYouDemoPage />} />
          </Routes>
        </main>

        <Footer />
        
        <BookingModal 
          isOpen={isBookingModalOpen} 
          onClose={() => setIsBookingModalOpen(false)} 
        />
        
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
